import { Injectable } from "@angular/core";
import { CONTRACTS_ABI, contractAddress, eContracts, eNetworkName } from "./contract.config";
import { Web3Service } from "../web3/web3.service";
import { getCookieValue } from "app/common/utils/cookie.util";

// declare const window

@Injectable({
    providedIn: 'root'
})

export class ContractsService {
    // private _contractInstance: ReplaySubject<any> = new ReplaySubject<any>(1);
    // private _contracts: Map<eContracts, ReplaySubject<any>> = new Map<eContracts, ReplaySubject<any>>();
    private contracts: Map<eContracts, any> = new Map<eContracts, any>();
    apiEndPoint: string;

    constructor(private web3Service: Web3Service) { }

    //getContract will set if it is not set yet a contract and return itself
    getContract(contractName: eContracts): any {
        this.setContract(contractName);
        return this.contracts.get(contractName);
    }

    setContract(contractName: eContracts, forceAddress?: string) {
        /* if (!this.contracts.get(contractName)) {
            let abi = CONTRACTS_ABI().filter(c => c.name === contractName)[0].abi;
            let address = contractAddress[this.networkName][contractName];
            this._contracts.set(contractName, new ReplaySubject<any>(1))
            this._contracts.get(contractName).next(new web3.eth.Contract(abi, address));
        } */
        let web3 = this.web3Service.getWeb3();
        let networkName = this.web3Service.getNetworkName();
        if (!this.contracts.get(contractName)) {
            let abi = CONTRACTS_ABI().filter(c => c.name === contractName)[0].abi;
            let address = forceAddress ? forceAddress : contractAddress[networkName][contractName];
            this.contracts.set(contractName, new web3.eth.Contract(abi, address));
        }
    }
    // setContractInstance(web3, abi: any, address: string) {
    //     this._contractInstance.next(new web3.eth.Contract(abi, address));
    // }



    getContractAddress(contract: eContracts): string {
        let networkName = this.web3Service.getNetworkName();
        return contractAddress[networkName][contract];
    }

    additionalParameters(): IAdditionalParameters {
        let provider: string = getCookieValue('login') == 'magic' ? 'magic' : 'metamask';
        let networkName = this.web3Service.getNetworkName();
        let _additionalParameters:
            {
                metamask: { [key in eNetworkName]: IAdditionalParameters },
                magic: { [key in eNetworkName]: IAdditionalParameters }
            } = {
            metamask: {
                bsc: {
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null
                },
                chapel: {
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null
                },
                polygon: {
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null
                },
                mumbai: {
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null
                },
                amoy: {
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null
                }
            },
            magic: {
                bsc: {
                    maxPriorityFeePerGas: this.web3Service.toWei(1, 'gwei'),
                    maxFeePerGas: this.web3Service.toWei(1, 'gwei'),
                },
                chapel: {
                    maxPriorityFeePerGas: this.web3Service.toWei(1, 'gwei'),
                    maxFeePerGas: this.web3Service.toWei(1, 'gwei'),
                },
                polygon: {
                    maxPriorityFeePerGas: null,
                    maxFeePerGas: null,
                },
                mumbai: {
                    maxPriorityFeePerGas: this.web3Service.toWei(3, 'gwei'),
                    maxFeePerGas: null,
                },
                amoy: {
                    maxPriorityFeePerGas: this.web3Service.toWei(3, 'gwei'),
                    maxFeePerGas: null,
                }
            }
        };
        return _additionalParameters[provider][networkName];
    }
}

export interface IAdditionalParameters {
    maxPriorityFeePerGas?: any
    maxFeePerGas?: any
}
